import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import ExampleList from './example-list';
import TabList from './tab-list';
import exampleStore from './store';
import globalStore from '@/store/global';
import { useMeasure } from 'react-use';

const Examples = observer(({ scene="" }) => {
  const [wrapRef, { width: widthContainer }] = useMeasure();
  const [listRef, { height: heightList }] = useMeasure();
  const [contentWidth, setContentWidth] = useState(1314);
  const [wrapHeight, setWrapHeight] = useState(0);
  const maxLine = globalStore.cloudConfig?.assistant_home_case?.maxLine || globalStore.cloudConfig?.assistant_home_case?.maxline || 0;

  const fitTabs = () => {
    if(contentWidth == 0) return
    let words = 0
    let quit = false
    exampleStore.data.tabList.forEach((item, index) => {
      if(quit) return
      words += item.title.length
      const width = words * 14 + (index + 1) * 30 + index * 13 + 80 + 58
      if(width >= contentWidth) {
        exampleStore.setData({
          tabShowMaxIndex: index - 1
        })
        quit = true
      }
    })
  }

  useEffect(() => {
    if(!exampleStore.data.activeTab) return
    exampleStore.setData({
      dataList: [],
      npt: ""
    })
    exampleStore.getExampleList((data) => {
      if(data?.npt) {
        exampleStore.getExampleList()
      }
    })
  }, [exampleStore.data.activeTab])

  useEffect(() => {
    if(widthContainer >= 1314) {
      setContentWidth(1314);
    }
    if(widthContainer <= 1314 && widthContainer >= 1314 - 266) {
      setContentWidth(1314 - 266);
    }
    if(widthContainer <= 1314 - 266 && widthContainer >= 1314 - 266 - 266) {
      setContentWidth(1314 - 266 - 266);
    }
  }, [widthContainer])

  useEffect(() => {
    setWrapHeight(heightList)
  }, [heightList])

  useEffect(() => {
    if(!exampleStore.data?.tabList?.length || !exampleStore.data.activeTab) {
      exampleStore.getCategory()
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      fitTabs()
    }, 50)
  }, [exampleStore.data.tabList, contentWidth])

  return (
    <div
      className={[
        'size-full flex flex-col items-center',
        scene == "examples" ? "h-auto" : ""
      ]}
      ref={wrapRef}
    >
      {
        scene == "home"
        ? (
          <>
            <div
              className='sticky top-0px z-100 bg-white pb-20px'
              style={{
                width: contentWidth
              }}
            >
              <TabList />
            </div>
            <div
              className='w-full overflow-hidden relative flex-shrink-0'
              style={{
                maxHeight: 251 * maxLine - 16 + "px",
                height: wrapHeight
              }}
            >
              <div
                className='absolute top-0 left-[50%] transform -translate-x-[50%]'
                ref={listRef}
                style={{
                  width: contentWidth
                }}
              >
                <ExampleList />
              </div>
            </div>
            <div className='h-127px mt-24px relative flex-shrink-0'>
              <div
                className='h-44px w-240px rounded-8px bg-black flex items-center justify-center gap-6px cursor-pointer absolute top-0px left-[50%] transform -translate-x-[50%] z-2 hover:bg-[#333333]'
                onClick={() => {
                  globalStore.navigate("/examples");
                }}
              >
                <div className='text-white text-16px font-bold'>
                  {"探索更多精彩作品"}
                </div>
                <img
                  src="https://p3.ssl.qhimg.com/t110b9a9301a420d12fc37d4b49.png"
                  className='size-12px'
                />
              </div>
              <div
                className='w-240px h-44px absolute top-7px left-[50%] transform -translate-x-[50%] z-1'
                style={{
                  backgroundImage: "url(https://p0.ssl.qhimg.com/t110b9a930174aba53059472e54.png)",
                  backgroundSize: "100% 100%"
                }}
              >
              </div>
            </div>
          </>
        )
        : null
      }
      {
        scene == "examples"
        ? (
          <>
            <div
              className='sticky top-0px z-20 bg-white pb-24px'
              style={{
                width: contentWidth
              }}
            >
              <TabList />
            </div>
            <div
              className='w-full flex flex-col items-center'
              id="examples_wrap"
            >
              <div
                className='flex justify-start'
                style={{
                  width: contentWidth
                }}
              >
                <ExampleList />
              </div>
              <div className={`w-full h-20px flex justify-center my-10px ${exampleStore.data.npt ? "opacity-100" : "opacity-0"}`}>
                加载中...
              </div>
            </div>
          </>
        )
        : null
      }
    </div>
  )
})

export default Examples
